import ServicoBuscaSession from "./servicoBuscaSession";

const TEMPO_LIMITE_SDK_MS = 10000;
const sdkPendente = {};
let avisoSdkIndisponivelExibido = false;
let avisoInicializacaoParcialExibido = false;

function obterSdkProntoParaTracking(metodo) {
    if (typeof window === "undefined" || !window.buscarService) {
        return null;
    }

    const sdk = window.buscarService;
    const configuracao = sdk.config || {};
    const metodoDisponivel = typeof sdk[metodo] === "function";
    const contextoDisponivel =
        configuracao.smarthintkey &&
        configuracao.session &&
        configuracao.SmartHint_AnonymousConsumer;

    return metodoDisponivel && contextoDisponivel ? sdk : null;
}

function avisarInicializacaoParcial() {
    const sdkInicializado =
        window.servicobusca && window.servicobusca.sdkInicializado;

    if (!sdkInicializado && !avisoInicializacaoParcialExibido) {
        avisoInicializacaoParcialExibido = true;
        console.info(
            "[ServicoBusca] SDK disponivel para tracking explicito; a inicializacao automatica foi ignorada."
        );
    }
}

function aguardarSdk(metodo) {
    if (typeof window === "undefined") {
        return Promise.reject(new Error("SDK indisponivel fora do navegador."));
    }

    const sdkDisponivel = obterSdkProntoParaTracking(metodo);

    if (sdkDisponivel) {
        avisoSdkIndisponivelExibido = false;
        avisarInicializacaoParcial();
        return Promise.resolve(sdkDisponivel);
    }

    if (sdkPendente[metodo]) {
        return sdkPendente[metodo];
    }

    sdkPendente[metodo] = new Promise((resolve, reject) => {
        let tempoLimite = null;
        let verificacaoSdk = null;

        const limparEspera = () => {
            window.removeEventListener("SDK_DICOMP_CARREGADO", sdkCarregado);
            clearTimeout(tempoLimite);
            clearInterval(verificacaoSdk);
        };

        const concluirSeDisponivel = () => {
            const sdkPronto = obterSdkProntoParaTracking(metodo);

            if (!sdkPronto) {
                return false;
            }

            limparEspera();
            avisarInicializacaoParcial();
            resolve(sdkPronto);
            return true;
        };

        const sdkCarregado = (event) => {
            if (event.detail && event.detail.nome !== "ServicoBusca") {
                return;
            }

            concluirSeDisponivel();
        };

        window.addEventListener("SDK_DICOMP_CARREGADO", sdkCarregado);
        verificacaoSdk = setInterval(concluirSeDisponivel, 100);

        tempoLimite = setTimeout(() => {
            limparEspera();
            reject(new Error("Tempo limite excedido ao aguardar o SDK."));
        }, TEMPO_LIMITE_SDK_MS);
    }).then(
        (sdk) => {
            sdkPendente[metodo] = null;
            avisoSdkIndisponivelExibido = false;
            return sdk;
        },
        (error) => {
            sdkPendente[metodo] = null;
            return Promise.reject(error);
        }
    );

    return sdkPendente[metodo];
}

function avisarFalha(error) {
    if (!avisoSdkIndisponivelExibido) {
        avisoSdkIndisponivelExibido = true;
        console.warn("[ServicoBusca] Nao foi possivel enviar o tracking.", error);
    }

    return false;
}

function executar(metodo, dados) {
    return aguardarSdk(metodo)
        .then((sdk) => {
            return Promise.resolve(sdk[metodo](dados)).then(() => true);
        })
        .catch(avisarFalha);
}

function enviarClick(dados) {
    const dadosClick = Object.assign({}, dados || {});
    const evento = dadosClick.evento;

    delete dadosClick.evento;

    if (evento) {
        const item = Array.isArray(evento.itens) ? evento.itens[0] : null;

        dadosClick.idProduto = item ? item.codigoProduto : undefined;
        dadosClick.precoProduto =
            item && item.preco !== undefined && item.preco !== null
                ? item.preco
                : 0;
        dadosClick.termo =
            evento.termo !== undefined && evento.termo !== null
                ? evento.termo
                : "";
    }

    if (!dadosClick.searchId) {
        dadosClick.searchId = ServicoBuscaSession.obterSearchId() || null;
    }

    return executar("enviarLogClick", dadosClick);
}

function enviarPagina(dados) {
    return executar("enviarLogPagina", Object.assign({}, dados || {}));
}

function formatarPedido(pedidoData) {
    const itens = Array.isArray(pedidoData.itens) ? pedidoData.itens : [];

    return {
        dataPedido: new Date().toLocaleString("pt-BR").replace(",", ""),
        codigo: pedidoData.codigo,
        valorTotal: pedidoData.total,
        codigoCliente: pedidoData.cliente_codigo,
        valorFrete: 0,
        itens: itens.map((item) => {
            const codigo = item.produto_codigo || item.codigo;
            return {
                codigo,
                nome: item.titulo || item.nome || "",
                quantidade: item.quantidade,
                sku: codigo
            };
        })
    };
}

function enviarPedido(pedidoData) {
    return Promise.resolve()
        .then(() => formatarPedido(pedidoData))
        .then((dados) => executar("enviarLogPedido", dados))
        .catch(avisarFalha);
}

export default {
    enviarClick,
    enviarPagina,
    enviarPedido,
    formatarPedido
};
